import {ValueDefinition} from '@/model/types';

export const enum ConversionType {
  TOTAL = 'DV-97#0',
  PARTIAL = 'DV-97#1',
}

export const DV_97 = {
  id: 'DV-97',
  description: {
    fr: 'Type de conversion',
    en: 'Conversion type',
  },
  values: [
    {
      id: '0',
      value: {
        fr: 'Totale',
        en: 'Total',
      },
    },
    {
      id: '1',
      value: {
        fr: 'Partielle',
        en: 'Partial',
      },
    },
  ],
} as const satisfies ValueDefinition;
